import React from 'react';

type Props = {
  setShowModal: (show: boolean) => void;
};
const HomeSlide = ({ setShowModal }: Props) => {
  return (
    <div className='rounded-md bg-[#F4F5F5] w-[100vw] min-h-[280px] px-[30px] pt-[42px] pb-[46px]'>
      <h3 className='text-[32px] font-semibold text-[#2E3031] mb-2'>
        Enjoy your favorite meals all day long
      </h3>
      <div className='w-full sm:w-[90%] md:w-[80%] lg:w-[65%] xl:w-[60%]'>
        <p className='text-[#3b3e3f] text-[18px] mb-10'>
          Show your appreciation to employees on their special days. Choose from a selection of
          thoughtful gifts and make their day brighter
        </p>
      </div>
      <div
        className='rounded bg-[#EBEBEB] cursor-pointer py-[10px] flex justify-center items-center w-[139px] h-[41px]'
        onClick={() => setShowModal(true)}>
        <p className='text-[#E60A2B] font-medium'>Learn more</p>
      </div>
    </div>
  );
};

export default HomeSlide;
